"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ManaMainnet = function (props) {
    return (react_1.default.createElement("svg", __assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" }, props),
        react_1.default.createElement("circle", { cx: "12", cy: "12", r: "12", fill: "url(#paint0_linear_32_9725)" }),
        react_1.default.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M12 5L19 12L12 19L5 12L12 5ZM12 6.96L17.04 12L12 17.04L6.96 12L12 6.96ZM12 14.52C12.6683 14.5201 13.3093 14.2547 13.782 13.7821C14.2546 13.3096 14.5202 12.6686 14.5203 12.0003C14.5204 11.3319 14.2549 10.6909 13.7824 10.2183C13.3099 9.74565 12.6689 9.48008 12.0006 9.48C11.3322 9.48 10.6913 9.7455 10.2187 10.2181C9.74608 10.6907 9.48058 11.3317 9.48058 12C9.48058 12.6683 9.74608 13.3093 10.2187 13.7819C10.6913 14.2545 11.3317 14.52 12 14.52Z", fill: "#FCFCFC" }),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("linearGradient", { id: "paint0_linear_32_9725", x1: "-0.631579", y1: "0.631579", x2: "24", y2: "24", gradientUnits: "userSpaceOnUse" },
                react_1.default.createElement("stop", { stopColor: "#34CE76" }),
                react_1.default.createElement("stop", { offset: "1", stopColor: "#229754" })))));
};
exports.default = ManaMainnet;
